import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import CookieBanner from '../../components/feature/CookieBanner';

export default function EmpresaPage() {
  return (
    <>
      <div className="min-h-screen flex flex-col">
        <Header />

        {/* Hero */}
        <section className="bg-gradient-to-br from-[#544E13] to-[#3a3610] text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Nuestra empresa</h1>
            <p className="text-xl text-gray-200 max-w-3xl">
              RESTAURAX es sinónimo de profesionalidad, experiencia y compromiso en la restauración post incendio en Hospitalet de Llobregat y Barcelona.
            </p>
          </div>
        </section>

        {/* Historia */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-6">
                  Nuestra historia y trayectoria
                </h2>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  <strong>RESTAURAX</strong> nació hace más de 15 años con una misión clara: ayudar a personas y empresas a recuperarse tras la devastación de un incendio. Fundada en <strong>Hospitalet de Llobregat</strong>, nuestra empresa comenzó como un pequeño equipo de profesionales especializados en <strong>limpieza post incendio</strong> y ha crecido hasta convertirse en una de las empresas de referencia en Barcelona y su área metropolitana.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Desde nuestros inicios, hemos trabajado incansablemente para perfeccionar nuestras técnicas de <strong>restauración post incendio</strong>, incorporando las últimas tecnologías en <strong>limpieza de hollín</strong>, <strong>eliminación de olores</strong> y <strong>tratamiento de ozono</strong>. Cada proyecto que hemos completado nos ha enseñado algo nuevo y nos ha permitido mejorar nuestros procesos para ofrecer un servicio cada vez más eficiente y profesional. Puedes conocer en detalle todos nuestros <Link to="/servicios" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">servicios especializados</Link>.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  A lo largo de estos años, hemos atendido cientos de emergencias en Hospitalet de Llobregat, Barcelona ciudad, Cornellà, Esplugues y municipios cercanos. Cada intervención ha reforzado nuestro compromiso con la excelencia y la satisfacción del cliente. Hemos trabajado en viviendas particulares, locales comerciales, oficinas, naves industriales y edificios públicos, siempre con el mismo nivel de profesionalidad y dedicación.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Nuestro crecimiento ha sido constante pero sostenible, priorizando siempre la calidad sobre la cantidad. Hemos invertido en formación continua para nuestro equipo, en equipamiento de última generación y en el desarrollo de protocolos de actuación que garantizan resultados óptimos en cada intervención de <strong>limpieza y restauración post incendio</strong>.
                </p>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Si tienes dudas sobre nuestros procesos o quieres conocer más detalles sobre cómo trabajamos, consulta nuestras <Link to="/faq" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">preguntas frecuentes</Link> donde resolvemos las consultas más habituales de nuestros clientes.
                </p>
              </div>
              <div>
                <img 
                  src="https://public.readdy.ai/ai/img_res/1cf0c711ad166f371b7d39dd7fdf8b56.jpg"
                  alt="Equipo profesional de RESTAURAX"
                  className="rounded-lg shadow-2xl w-full h-auto object-cover object-top transition-transform duration-500 ease-in-out hover:scale-105 cursor-pointer"
                  title="Equipo RESTAURAX especializado en restauración post incendio"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Valores */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-12 text-center">
              Nuestros valores y principios
            </h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Profesionalidad</h3>
                <p className="text-gray-600 leading-relaxed">
                  Actuamos con el máximo rigor profesional en cada intervención de <strong>restauración post incendio</strong>. Nuestro equipo está certificado y en constante formación para ofrecer el mejor servicio en Hospitalet de Llobregat y Barcelona.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-heart-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Empatía</h3>
                <p className="text-gray-600 leading-relaxed">
                  Entendemos el trauma que supone sufrir un incendio. Tratamos cada caso con sensibilidad y comprensión, ofreciendo apoyo emocional además de nuestros servicios técnicos de <strong>limpieza de hollín</strong> y restauración.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-time-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Rapidez</h3>
                <p className="text-gray-600 leading-relaxed">
                  En emergencias post incendio, cada minuto cuenta. Por eso ofrecemos servicio 24/7 y nos comprometemos a actuar con la máxima celeridad en toda el área de Barcelona y Hospitalet de Llobregat.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-checkbox-circle-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Calidad</h3>
                <p className="text-gray-600 leading-relaxed">
                  No aceptamos medias tintas. Cada trabajo de <strong>limpieza post incendio</strong>, <strong>eliminación de olores</strong> o <strong>tratamiento de ozono</strong> se realiza con los más altos estándares de calidad hasta lograr resultados impecables.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-hand-heart-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Honestidad</h3>
                <p className="text-gray-600 leading-relaxed">
                  Transparencia total en presupuestos, plazos y procesos. Nuestros clientes en Hospitalet de Llobregat y Barcelona siempre saben qué esperar y reciben información clara y veraz en todo momento.
                </p>
              </div>

              <div className="bg-white rounded-lg p-8 shadow-lg">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-leaf-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Responsabilidad ambiental</h3>
                <p className="text-gray-600 leading-relaxed">
                  Utilizamos productos y técnicas respetuosas con el medio ambiente. Nuestro <strong>tratamiento de ozono</strong> y métodos de limpieza son ecológicos y seguros para personas y mascotas.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Misión y Visión */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-12">
              <div className="bg-gradient-to-br from-[#F2D70A] to-[#e5ca09] rounded-lg p-8">
                <div className="w-16 h-16 bg-[#544E13] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-compass-3-line text-3xl text-white"></i>
                </div>
                <h2 className="text-2xl font-bold text-[#544E13] mb-4">Nuestra misión</h2>
                <p className="text-[#544E13] leading-relaxed">
                  Nuestra misión es devolver la normalidad a hogares y negocios afectados por incendios en <strong>Hospitalet de Llobregat</strong> y Barcelona, ofreciendo servicios integrales de <strong>limpieza y restauración post incendio</strong> con la máxima calidad, rapidez y profesionalidad. Nos comprometemos a ser el apoyo que nuestros clientes necesitan en los momentos más difíciles, proporcionando soluciones efectivas que van desde la <strong>limpieza de hollín</strong> hasta la restauración completa del espacio.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#544E13] to-[#3a3610] rounded-lg p-8 text-white">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-eye-line text-3xl text-[#544E13]"></i>
                </div>
                <h2 className="text-2xl font-bold mb-4">Nuestra visión</h2>
                <p className="text-gray-200 leading-relaxed">
                  Aspiramos a ser la empresa de referencia en <strong>restauración post incendio</strong> en toda Cataluña, reconocida por nuestra excelencia técnica, innovación constante y compromiso inquebrantable con la satisfacción del cliente. Queremos expandir nuestros servicios manteniendo los valores que nos han convertido en líderes en Hospitalet de Llobregat y Barcelona, incorporando las últimas tecnologías en <strong>eliminación de olores</strong> y <strong>tratamiento de ozono</strong>.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Equipo */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-6 text-center">
              Nuestro equipo profesional
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
              El corazón de RESTAURAX es nuestro equipo de profesionales altamente cualificados y comprometidos con la excelencia en cada intervención de restauración post incendio.
            </p>

            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-24 h-24 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-star-line text-4xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-2">Técnicos certificados</h3>
                <p className="text-gray-600">
                  Todos nuestros técnicos cuentan con certificaciones oficiales en <strong>limpieza post incendio</strong>, <strong>tratamiento de ozono</strong> y restauración de espacios dañados.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-24 h-24 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-graduation-cap-line text-4xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-2">Formación continua</h3>
                <p className="text-gray-600">
                  Invertimos en formación constante para que nuestro equipo esté al día de las últimas técnicas en <strong>eliminación de olores</strong> y restauración.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-24 h-24 bg-[#F2D70A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-4xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-2">Trabajo en equipo</h3>
                <p className="text-gray-600">
                  Coordinación perfecta entre todos los miembros para garantizar intervenciones rápidas y eficaces en Hospitalet de Llobregat y Barcelona.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-lg">
              <p className="text-gray-700 leading-relaxed mb-4">
                Nuestro equipo está compuesto por especialistas en diferentes áreas de la <strong>restauración post incendio</strong>: expertos en <strong>limpieza de hollín</strong>, técnicos en <strong>tratamiento de ozono</strong>, profesionales del <strong>desescombro</strong>, pintores especializados y maestros de obra para pequeñas reparaciones. Esta diversidad de perfiles nos permite ofrecer un servicio integral y completo.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Cada miembro del equipo RESTAURAX comparte nuestra pasión por ayudar a las personas a recuperarse tras un incendio. Trabajamos con vocación de servicio, entendiendo que detrás de cada intervención hay familias o empresarios que necesitan recuperar su espacio y su tranquilidad lo antes posible.
              </p>
              <p className="text-gray-700 leading-relaxed">
                La experiencia acumulada de nuestro equipo supera los 100 años combinados en el sector de la <strong>limpieza y restauración post incendio</strong> en Barcelona y Hospitalet de Llobregat. Esta experiencia, sumada a nuestra formación continua y compromiso con la excelencia, nos convierte en el equipo más preparado para afrontar cualquier desafío en restauración post incendio.
              </p>
            </div>
          </div>
        </section>

        {/* Garantías */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-12 text-center">
              Nuestras garantías y compromisos
            </h2>

            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-[#544E13]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#544E13] mb-2">Garantía de satisfacción</h3>
                  <p className="text-gray-600">
                    Garantizamos la satisfacción total con nuestros servicios de <strong>limpieza post incendio</strong>. Si no quedas completamente satisfecho, repetimos el trabajo sin coste adicional.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-shield-line text-2xl text-[#544E13]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#544E13] mb-2">Seguro de responsabilidad civil</h3>
                  <p className="text-gray-600">
                    Contamos con un completo seguro de responsabilidad civil que cubre cualquier eventualidad durante nuestras intervenciones en Hospitalet de Llobregat y Barcelona.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-price-tag-3-line text-2xl text-[#544E13]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#544E13] mb-2">Presupuestos transparentes</h3>
                  <p className="text-gray-600">
                    Presupuestos detallados y sin letra pequeña. Sabrás exactamente qué incluye cada servicio de <strong>restauración post incendio</strong> y cuánto cuesta.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-check-line text-2xl text-[#544E13]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#544E13] mb-2">Cumplimiento de plazos</h3>
                  <p className="text-gray-600">
                    Nos comprometemos a cumplir los plazos acordados. Planificamos cada intervención de <strong>limpieza de hollín</strong> y restauración para minimizar las molestias.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-customer-service-2-line text-2xl text-[#544E13]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#544E13] mb-2">Atención personalizada</h3>
                  <p className="text-gray-600">
                    Cada cliente tiene asignado un responsable que le informa del progreso y resuelve cualquier duda durante todo el proceso de restauración.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-recycle-line text-2xl text-[#544E13]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#544E13] mb-2">Gestión de residuos</h3>
                  <p className="text-gray-600">
                    Nos encargamos de la gestión legal y ecológica de todos los residuos generados durante el <strong>desescombro</strong> y la limpieza post incendio.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-[#F2D70A] to-[#e5ca09] rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold text-[#544E13] mb-4">
                Más de 15 años de experiencia avalan nuestro trabajo
              </h3>
              <p className="text-lg text-[#544E13] mb-6">
                Cientos de clientes satisfechos en Hospitalet de Llobregat, Barcelona y alrededores confían en RESTAURAX para la restauración de sus espacios tras un incendio. ¿Quieres saber más sobre nuestros métodos? Consulta nuestras <Link to="/faq" className="text-[#544E13] hover:text-white font-bold underline">preguntas frecuentes</Link>.
              </p>
              <Link 
                to="/contacto"
                className="inline-block bg-[#544E13] text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#544E13] transition-all whitespace-nowrap cursor-pointer"
              >
                Solicita tu Presupuesto Gratuito
              </Link>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-gradient-to-br from-[#544E13] to-[#3a3610] text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Confía en los expertos en restauración post incendio
            </h2>
            <p className="text-xl mb-8 text-gray-200">
              RESTAURAX está aquí para ayudarte a recuperar tu espacio. Contacta con nosotros y descubre por qué somos la empresa de confianza en Hospitalet de Llobregat y Barcelona.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/servicios"
                className="bg-[#F2D70A] text-[#544E13] px-8 py-4 rounded-lg font-bold text-lg hover:bg-white transition-all whitespace-nowrap cursor-pointer"
              >
                Ver Nuestros Servicios
              </Link>
              <a 
                href="tel:690220944"
                className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#544E13] transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                690 22 09 44
              </a>
            </div>
          </div>
        </section>

        <Footer />
        <WhatsAppButton />
        <ScrollToTopButton />
      </div>
    </>
  );
}